import React from "react";

import { Box } from "@material-ui/core";

export const ContentWrapper = ({ ...props }: any) => {
  return (
    <Box
      padding="50px 20px"
      bgcolor="#F2F5F7"
      display="flex"
      justifyContent="center"
      minHeight="100vh"
      {...props}
    />
  );
};
